<template>
  <CardTmpl :space="call.Space" :class="cardClass" is-free>
    <template slot="header">
      <v-icon color="grey lighten-2" class="mr-1">mdi-car-brake-parking</v-icon>
      <span :class="titleClass"> {{ call.Space }} </span>
    </template>

    <template slot="content">
      <v-row justify="center" align="center" @drop.prevent="parkDrop"
        @dragover.prevent="dragParkCallOver" @dragleave.prevent="dragParkOver=false">
        <v-col md="12" justify="center" align="center">
          <div style="height: 198px;display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div :class="textClass">
              {{
              dragParkOver
              ? $t('parking.dropToPark')
              : $t('parking.freeSlot')
              }}
            </div>
            <v-icon x-large color="grey lighten-3" >mdi-car-brake-parking</v-icon>
          </div>
        </v-col>
      </v-row>
    </template>

    <template slot="actions">
      <v-spacer></v-spacer>
      <v-btn fab x-small disabled depressed color="primary">
        <v-icon>mdi-phone-return</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </template>
  </CardTmpl>
</template>

<script>
import events from 'Store/events'
import CardTmpl from './card_tmpl'

export default {
  name: 'parking-free-slot',
  components: { CardTmpl },
  data () {
    return {
      dragParkOver: false
    }
  },
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  computed: {
    textClass: function () {
      const css = [
        'text-h4',
        'text-center',
        'font-weight-black',
        'text-uppercase'
      ]
      if (!this.dragParkOver) {
        css.push('text--lighten-3 grey--text')
      }

      return css
    },
    titleClass: function () {
      const css = ['ml-2', 'grey--text']
      if (this.dragParkOver) {
        css.push('text--darken-4')
      } else {
        css.push('text--lighten-1')
      }
      return css
    },
    cardClass: function () {
      if (this.dragParkOver) {
        return ['elevation-4']
      }
      return []
    }
  },
  methods: {
    dragParkCallOver: function (e) {
      if (e.dataTransfer.types.includes('call/json')) {
        this.dragParkOver = true
      }
    },
    parkDrop: function (e) {
      if (!this.dragParkOver) return
      this.dragParkOver = false
      const data = e.dataTransfer.getData('call/json')
      if (!data) {
        this.dbg('ERROR: Failed call x-fer. Missing drag-n-drop call json data')
        return
      }
      const call = JSON.parse(data)
      const callID = call.callid
      if (!callID) {
        events.pubError('Failed to park call. Missing call-id. System error')
        return
      }
      this.$emit('direct-park', { callid: callID })
    }
  }
}
</script>

<style scoped>
</style>
